import { getApiErrorMessage } from "./apiErrorHandler";

export const handleApiRequest = async ({
    requestFn,
    onSuccess,
    onError,
    finallyFn,
    showError,
    setError,
}) => {
    try {
        const res = await requestFn();
        if (onSuccess) onSuccess(res);
    } catch (error) {
        const message = getApiErrorMessage(error);
        if (setError) setError(message);
        if (showError) showError(message);
        if (onError) onError(message);
    } finally {
        if (finallyFn) finallyFn();
    }
};
